import React from 'react';
import DailyGuestsPanel from '../components/DailyGuestsPanel';
import { useAuth } from '../context/AuthContext';
import './DailyGuests.css';

const DailyGuests: React.FC = () => {
  const { hostel } = useAuth();

  if (!hostel?.id) {
    return (
      <div className="daily-guests-page">
        <p className="daily-guests-page__empty">Select an active hostel to manage daily guests.</p>
      </div>
    );
  }

  return (
    <div className="dashboard-container daily-guests-page">
      <header className="daily-guests-page__header">
        <div>
          <h1 className="daily-guests-page__title">Daily guests</h1>
          <p className="daily-guests-page__sub">Short-stay guests, check-in/out, and payments</p>
        </div>
      </header>
      <DailyGuestsPanel hostelId={hostel.id} />
    </div>
  );
};

export default DailyGuests;
